const prefix = 'CALENDAR';

export const ADD_EVENTS = Symbol(`${prefix}/ADD_EVENTS`);
export const ADD_EVENTS_SUCCESS = Symbol(`${prefix}/ADD_EVENTS_SUCCESS`);
export const UPDATE_EVENT = Symbol(`${prefix}/UPDATE_EVENT`);
export const UPDATE_EVENT_SUCCESS = Symbol(`${prefix}/UPDATE_EVENT_SUCCESS`);
export const REMOVE_EVENT = Symbol(`${prefix}/REMOVE_EVENT`);
export const REMOVE_EVENT_SUCCESS = Symbol(`${prefix}/REMOVE_EVENT_SUCCESS`);
export const FINISH_LOADING_EVENTS = Symbol(`${prefix}/FINISH_LOADING_EVENTS`);
